/** 资源通用信息 **/

const state = {
  softwareVersionNameMap: [],
  permissionGroups: []
}

const getters = {
  softwareVersionNameMap: (state) => state.softwareVersionNameMap,
  permissionGroups: (state) => state.permissionGroups
}

const mutations = {
  setSoftwareVersionNameMap(state, data) {
    state.softwareVersionNameMap = data
  },
  setPermissionGroups(state, data) {
    state.permissionGroups = data
  }
}

const actions = {
  // 获取公共资源详情
  async loadSoftwareVersionNameMap({ commit }, payload) {
    try {
      const { space_id, software_code } = payload
      const data = await this.$api.software.softwareVersionNameMappingList(space_id, { software_code })
      commit('setSoftwareVersionNameMap', data || [])
    } catch (error) {
      commit('setSoftwareVersionNameMap', [])
    }
  },
  async getPermissionGroups({ commit }) {
    const data = await this.$api.member.getPermissionGroups()
    commit('setPermissionGroups', data || [])
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
